module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fixed-top"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#/home"
    }
  }, [_c('img', {
    attrs: {
      "src": require('assets/images/logo.png'),
      "alt": "OpenCabana"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleNavbarMenu()
      }
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('div', {
    staticClass: "sidebar-menu-wrapper"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('locations')
      }
    }
  }, [_vm._v("BOOK A CABANA")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-area text-center"
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [(!_vm.isLoggedIn) ? _c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSidebarLink('login')
      }
    }
  }, [_vm._v("GUEST LOGIN")])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('li', {
    staticClass: "sidebar-menu-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("LOGOUT")])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("© " + _vm._s(_vm.date) + " - All rights reserved.")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-group"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/opencabana/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.twitter.com/opencabana/"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/opencabana/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/opencabana/"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-198e8e27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = 590
// module chunks = 2